import React from "react";
import "./SummaryCard.css";
import { Globals as OldGlobals } from "../../global/Globals";
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from "../../context/Languagecontext";

const SummaryCard = (props) => {
  const { Globals } = useLanguage();
  const title = props.title.toUpperCase();
  const Title=Globals.SUMMARY_CARD_NAME[props.title];
  const imageSrc = OldGlobals.IMG[title];
  const roleID = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const multiLang = localStorage.getItem("lang");
  
  return (
    <>
      <div className="status-box">
        <div className="status">
              <img src={imageSrc} />
          <div className={`summaryCardstatusTitle cardsumm-${multiLang} ${roleID === Globals.USER_ROLES.PRODUCER ? `producerstatustitle producercardsumm-${multiLang}`: ""}`} title={Title}>{Title}</div>
        </div>
        <span class="number">{props.count}</span>
      </div>
    </>
  );
};

export default SummaryCard;
